module.exports = __webpack_public_path__ + "img/bowimg@2x.b49e4792.png";